import { render, staticRenderFns } from "./system-emails-tab.vue?vue&type=template&id=2838cc1c"
import script from "./system-emails-tab.vue?vue&type=script&lang=js"
export * from "./system-emails-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports